import { Injectable, EventEmitter, Output } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class UpdateinfoService {
  progress$: any;
  private progressObserver: any;
  private progress: any;
  invokeIsEditProfilePic = new EventEmitter();
  subsIsEditProfilePic: Subscription;

  invokeIsShowPorfilePic = new EventEmitter();
  subsIsShowProfilePic: Subscription;

  constructor(private GenericUtility: GenericUtilityService) {
    this.progress$ = Observable.create((observer: any) => {
      this.progressObserver = observer
    })
  }
  onIsEditProfilePic() {
    this.invokeIsEditProfilePic.emit();
  }

  onIsShowProfilePic() {
    this.invokeIsShowPorfilePic.emit();
  }

  UpdatePatientInfo(data: any) {
    return this.GenericUtility.ApiPostMethod("checkinform", "UpdatePatientDemographics", data);
  }
  getZipCityState(zipcode: any, patientAccount: any, practiceCode: any ) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/ZipCityState?PracticeCode="+practiceCode+"&PatientAccount="+patientAccount+"&ZipCode="+zipcode);
  }
  GetracesDropdown(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetRacesDropdowns?PatientAccount=" + PATIENT_ACCOUNT + "&PracticeCode=" + PRACTICE_CODE);
  }
  GetCityState(data: any) {
    return this.GenericUtility.ApiPostMethod("checkinform", "GetCityStateAginstZipCode", data);
  }
  GetEnthincitiesDropdowns(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetEthnicitiesDropdown?PatientAccount=" + PATIENT_ACCOUNT + "&PracticeCode=" + PRACTICE_CODE);
  }
  GetLanguageDropdowns(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetLanguageDropdown?PatientAccount=" + PATIENT_ACCOUNT + "&PracticeCode=" + PRACTICE_CODE);
  }
  SearchPatientPharmacy(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "SearchPatientPharmacy", data);
  }
  GetPatientEthnicities(PATIENT_ACCOUNT: any, PRACTICE_CODE:any) {
    return this.GenericUtility.ApiGetMethod("checkinform/GetPatientEthnicities?PATIENT_ACCOUNT=" + PATIENT_ACCOUNT + "&PRACTICE_CODE=" + PRACTICE_CODE);
  }
  GetPatientPharmacies(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.GenericUtility.ApiGetMethod("checkinform/GetPatientPharmacies?PATIENT_ACCOUNT=" + PATIENT_ACCOUNT + "&PRACTICE_CODE=" + PRACTICE_CODE);
  }

  AddUpdatePharmacy(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "AddUpdatePharmacy", data);
  }

  uploadAtFolder(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {

    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE);
  }
  private makeFileRequest(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.GenericUtility.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("ProfilePicture", files);
      //formData.append("uploads", files[i].name);
      //formData.append("size", files[i], files[i].size.toString());
      //formData.append("type", files[i], files[i].type);
      // }
      //add JWT token for save profile pic
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }
  GetPracticeDocumentsServer(patientAccount: any, practiceCode: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetPracticeDocumentsServer?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount);
  }
}
